/**
 * Слушатели команд поиска: команда «перечитать состояние поиска» уходит в порт, а не в запрос напрямую —
 * так модель не знает, как именно состояние читается.
 */
import { defineListener, type ModuleListener } from '@krp/client-runtime'

import { searchHealthRequested } from './commands'
import type { SearchPortsFactory } from './ports'

export function createSearchListeners<S>(makePorts: SearchPortsFactory): ModuleListener<S>[] {
  return [
    defineListener<S, ReturnType<typeof searchHealthRequested>>(searchHealthRequested.match, (_action, api) => {
      makePorts(api.dispatch).reloadHealth()
    }),
  ]
}
